<template>
  <div class="d-flex meeting-resolutions-tunnel">
    <div v-for="(resolution, index) in meetingResolutions" :key="`p-${resolution.id}`">
      <div class="d-flex">
        <div class="tunnel-btn-row-1-container">
          <!-- button remove RESOLUTION -->
          <b-button
            v-if="
              !meetingIsCompleted &&
              resolution.created_during_meeting &&
              !resolutionIsActiveNow(resolution)
            "
            class="button tunnel-btn tunnel-btn-danger tunnel-btn-remove-resolution"
            title="supprimer résolution"
            @click="deleteResolutionDuringMeeting(resolution)"
          >
            <font-awesome-icon icon="times"></font-awesome-icon>
          </b-button>
          <b-button
            class="button tunnel-btn tunnel-btn-row-1"
            :class="{
              'tunnel-btn-active':
                currentResolutionId == resolution.id || currentParentResolutionId == resolution.id,
              'tunnel-btn-started': startedMeetingResolutionId == resolution.id,
              'tunnel-btn-corrected': correctedMeetingResolutionId == resolution.id,
            }"
            @click="changeResolution(resolution.id)"
          >
            {{ resolution.resolution_number }}
          </b-button>
        </div>
        <div class="tunnel-line-container">
          <!-- button add RESOLUTION -->
          <b-button
            v-if="!meetingIsCompleted"
            class="button tunnel-btn tunnel-btn-primary tunnel-btn-add-resolution"
            title="ajouter une résolution"
            @click="openModalCreateResolution(resolution.id)"
          >
            <font-awesome-icon icon="plus"></font-awesome-icon>
          </b-button>
          <div v-if="index !== meetingResolutions.length - 1" class="tunnel-line"></div>
        </div>
      </div>
      <div v-if="resolution.children_resolutions.length == 0 && resolution.status" class="d-flex">
        <div class="tunnel-icon-row-2-container d-flex justify-content-center align-items-center">
          <font-awesome-icon
            v-if="resolution.status == meetingResolutionStatuses.accepted"
            icon="thumbs-up"
            class="text-success tunnel-icon-row-2"
          />
          <font-awesome-icon
            v-else-if="resolution.status == meetingResolutionStatuses.rejected"
            icon="thumbs-down"
            class="text-danger tunnel-icon-row-2"
          />
          <font-awesome-icon
            v-else-if="resolution.status == meetingResolutionStatuses.not_resolved"
            icon="hand-rock"
            class="text-dark tunnel-icon-row-2"
          />
          <font-awesome-icon
            v-else-if="resolution.status == meetingResolutionStatuses.sans_vote"
            icon="thumbs-up"
            class="text-secondary tunnel-icon-row-2"
          />
          <font-awesome-icon
            v-else-if="resolution.status == meetingResolutionStatuses.rejected_lack_of_majority"
            icon="thumbs-down"
            class="text-danger tunnel-icon-row-2"
          />
          <font-awesome-icon
            v-else-if="resolution.status == meetingResolutionStatuses.not_voted"
            icon="hand-rock"
            class="text-dark tunnel-icon-row-2"
          />
          <div
            v-if="showResolutionWarningForVotingInconsistency(resolution.id)"
            class="d-flex align-items-center ml-2"
          >
            <font-awesome-icon
              :id="`popover-warning-end-date-${resolution.id}`"
              icon="exclamation-triangle"
              class="color-yellow font-16"
            />
            <b-popover
              :target="`popover-warning-end-date-${resolution.id}`"
              triggers="hover"
              placement="top"
            >
              Certains copropriétaires sont venus plus tard à l'assemblée et n'ont pas voté cette
              résolution.
            </b-popover>
          </div>
        </div>
      </div>
      <div v-if="!resolution.status" class="tunnel-row-2-container d-flex">
        <!-- offset -->
        <div class="tunnel-offset-row-2"></div>
        <div
          v-for="childResolution in resolution.children_resolutions"
          :key="`c1-${childResolution.id}`"
          class="tunnel-btn-row-2-container"
        >
          <!-- button remove SUB RESOLUTION -->
          <b-button
            v-if="
              !meetingIsCompleted &&
              childResolution.created_during_meeting &&
              !resolutionIsActiveNow(childResolution)
            "
            class="button tunnel-btn tunnel-btn-danger tunnel-btn-remove-sub-resolution"
            title="supprimer résolution"
            @click="deleteResolutionDuringMeeting(childResolution)"
          >
            <font-awesome-icon icon="times"></font-awesome-icon>
          </b-button>
          <b-button
            class="button tunnel-btn tunnel-btn-row-2"
            :class="{
              'tunnel-btn-active': currentResolutionId == childResolution.id,
              'tunnel-btn-started': startedMeetingResolutionId == childResolution.id,
            }"
            @click="changeResolution(childResolution.id)"
          >
            {{ `${resolution.resolution_number}.${childResolution.resolution_number}` }}
          </b-button>
        </div>
        <!-- button add sub resolutions -->
        <div
          v-if="
            (currentResolutionId == resolution.id || currentParentResolutionId == resolution.id) &&
            !meetingIsCompleted &&
            !hasMinutesResolutionVote(resolution.id)
          "
          class="tunnel-btn-row-2-container d-flex align-items-center justify-content-center"
        >
          <b-button
            class="button tunnel-btn tunnel-btn-primary tunnel-btn-row-2 tunnel-btn-add-sub-resolution"
            title="ajouter une sous-résolution"
            @click="openModalCreateSubResolution(resolution.id)"
          >
            <font-awesome-icon icon="plus"></font-awesome-icon>
          </b-button>
        </div>
      </div>
      <div v-if="resolution.children_resolutions.length > 0" class="d-flex">
        <!-- offset -->
        <div class="tunnel-offset-row-3"></div>
        <div
          v-for="childResolution in resolution.children_resolutions"
          :key="`c2-${childResolution.id}`"
          class="tunnel-icon-row-3-container d-flex justify-content-center align-items-center"
        >
          <font-awesome-icon
            v-if="childResolution.status == meetingResolutionStatuses.accepted"
            icon="thumbs-up"
            class="text-success tunnel-icon-row-3"
          />
          <font-awesome-icon
            v-else-if="childResolution.status == meetingResolutionStatuses.rejected"
            icon="thumbs-down"
            class="text-danger tunnel-icon-row-3"
          />
          <font-awesome-icon
            v-else-if="childResolution.status == meetingResolutionStatuses.not_resolved"
            icon="hand-rock"
            class="text-dark tunnel-icon-row-3"
          />
          <font-awesome-icon
            v-else-if="childResolution.status == meetingResolutionStatuses.sans_vote"
            icon="thumbs-up"
            class="text-secondary tunnel-icon-row-3"
          />
          <font-awesome-icon
            v-else-if="
              childResolution.status == meetingResolutionStatuses.rejected_lack_of_majority
            "
            icon="thumbs-down"
            class="text-danger tunnel-icon-row-3"
          />
          <font-awesome-icon
            v-else-if="childResolution.status == meetingResolutionStatuses.not_voted"
            icon="hand-rock"
            class="text-dark tunnel-icon-row-3"
          />
          <div
            v-if="showResolutionWarningForVotingInconsistency(childResolution.id)"
            class="d-flex align-items-center ml-1"
          >
            <font-awesome-icon
              :id="`popover-warning-end-date-${childResolution.id}`"
              icon="exclamation-triangle"
              class="color-yellow font-12"
            />
            <b-popover
              :target="`popover-warning-end-date-${childResolution.id}`"
              triggers="hover"
              placement="top"
            >
              Certains copropriétaires sont venus plus tard à l'assemblée et n'ont pas voté cette
              résolution.
            </b-popover>
          </div>
        </div>
      </div>
      <!-- modal create SUB RESOLUTION -->
      <b-modal
        v-if="showModalsCreateSubResolution[resolution.id]"
        :id="`modal-create-sub-resolution-${resolution.id}`"
        size="lg"
        hide-footer
        centered
        :visible="true"
        @hide="closeModalCreateSubResolution(resolution.id)"
      >
        <appResolution
          :is-new="true"
          :is-in-meeting="true"
          :meeting-id="meetingId"
          :building-id="buildingId"
          :meeting-is-completed="meetingIsCompleted"
          :parent-resolution-on-create-during-meeting="resolution"
          @cancel="closeModalCreateSubResolution(resolution.id)"
          @createResolutionDuringMeeting="createResolutionDuringMeeting($event, resolution)"
        />
      </b-modal>
      <!-- modal create RESOLUTION -->
      <b-modal
        v-if="showModalsCreateResolution[resolution.id]"
        :id="`modal-create-resolution-${resolution.id}`"
        size="lg"
        hide-footer
        centered
        :visible="true"
        @hide="closeModalCreateResolution(resolution.id)"
      >
        <appResolution
          :is-new="true"
          :is-in-meeting="true"
          :is-created-in-meeting-start="true"
          :meeting-id="meetingId"
          :building-id="buildingId"
          :meeting-is-completed="meetingIsCompleted"
          :prior-positioned-resolution-on-create-during-meeting="resolution"
          @cancel="closeModalCreateResolution(resolution.id)"
          @createResolutionDuringMeeting="createResolutionDuringMeeting($event, resolution)"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import modalCreateSubResolution from "@/components/modals/CreateSubResolution";
import appResolution from "@/components/catalogs/resolutions/Resolution";
import MeetingResolutionMW from "@/middlewares/MeetingResolution";
import { meetingMinutesNames } from "@/constants/meeting.js";
import MeetingORM from "@/store/orm-axios/models/Meeting";

export default {
  components: {
    modalCreateSubResolution,
    appResolution,
  },
  props: {
    meetingResolutions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    currentResolutionId: {
      type: String,
      default: "",
    },
    currentParentResolutionId: {
      type: String,
      default: "",
    },
    startedMeetingResolutionId: {
      type: String,
      default: "",
    },
    correctedMeetingResolutionId: {
      type: String,
      default: "",
    },
    meetingId: {
      type: String,
      default: "",
    },
    buildingId: {
      type: String,
      default: "",
    },
    meetingIsCompleted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      meetingMinutesNames,
      showModalsCreateResolution: {},
      showModalsCreateSubResolution: {},
    };
  },
  computed: {
    resolutionIsActiveNow() {
      return resolution => {
        return (
          resolution.id == this.currentResolutionId ||
          resolution.id == this.currentParentResolutionId ||
          resolution.id == this.startedMeetingResolutionId
        );
      };
    },
    meeting() {
      return MeetingORM.getters("getById")(this.meetingId);
    },
  },
  methods: {
    changeResolution(resolutionId) {
      this.$emit("changeResolution", resolutionId);
    },
    // ..
    openModalCreateResolution(resolutionId) {
      this.$set(this.showModalsCreateResolution, resolutionId, true);
    },
    closeModalCreateResolution(resolutionId) {
      this.$set(this.showModalsCreateResolution, resolutionId, false);
    },
    async createResolutionDuringMeeting(resolutionToCreate, priorOrParentResolution) {
      try {
        this.$store.state.showLoaderOverlay = true;

        await MeetingResolutionMW.CREATE_DURING_MEETING(resolutionToCreate);

        this.$store.state.showLoaderOverlay = false;
        this.closeModalCreateResolution(priorOrParentResolution.id);
        this.closeModalCreateSubResolution(priorOrParentResolution.id);
      } catch (err) {
        this.$store.state.showLoaderOverlay = false;
        console.error(err);
        this.$swal(this.alertError());
      }
    },
    async deleteResolutionDuringMeeting(resolutionToDelete) {
      var self = this;
      try {
        await self.$swal(self.alertQuestion()).then(async res => {
          if (res.value) {
            this.$store.state.showLoaderOverlay = true;

            await MeetingResolutionMW.DELETE_DURING_MEETING(resolutionToDelete);

            this.$store.state.showLoaderOverlay = false;
            self.$emit("deletedMeetingResolutionDuringMeeting", resolutionToDelete.id);
          }
        });
      } catch (err) {
        this.$store.state.showLoaderOverlay = false;
        console.error(err);
        this.$swal(this.alertError());
      }
    },
    openModalCreateSubResolution(parentResolutionId) {
      this.$set(this.showModalsCreateSubResolution, parentResolutionId, true);
    },
    closeModalCreateSubResolution(parentResolutionId) {
      this.$set(this.showModalsCreateSubResolution, parentResolutionId, false);
    },
    showResolutionWarningForVotingInconsistency(resolutionId) {
      const minutes = this.meeting.minutes;

      const resolutionVoteEvent = minutes.find(
        item =>
          item.event == this.meetingMinutesNames.resolution_vote &&
          item.resolution_id == resolutionId
      );

      if (!resolutionVoteEvent) return false;

      const arrivedAfterResolution = minutes.filter(
        event =>
          (event.event == this.meetingMinutesNames.participant_arrived ||
            event.event == this.meetingMinutesNames.contact_arrived ||
            event.event == this.meetingMinutesNames.mandate_added) &&
          event.date &&
          event.date > resolutionVoteEvent.date
      );

      const mandatesStillPresent = [];
      for (const minuteEvent of arrivedAfterResolution) {
        const hasEventLeft = minutes.find(
          event =>
            (event.event == this.meetingMinutesNames.participant_left ||
              event.event == this.meetingMinutesNames.contact_left ||
              event.event == this.meetingMinutesNames.mandate_left) &&
            event.date &&
            event.date > resolutionVoteEvent.date &&
            event.mandate_id == minuteEvent.mandate_id
        );
        if (!hasEventLeft) {
          mandatesStillPresent.push(minuteEvent);
        }
      }

      if (mandatesStillPresent.length > 0) {
        return true;
      }
      return false;
    },
    hasMinutesResolutionVote(resolutionId) {
      const minutes = this.meeting.minutes;

      const resolutionVoteEvent = minutes.find(
        item =>
          item.event == this.meetingMinutesNames.resolution_vote &&
          item.resolution_id == resolutionId
      );

      if (!resolutionVoteEvent) return false;
      return true;
    },
  },
};
</script>
